import { AUTH_ROUTE_FALLBACK, AUTH_STORAGE_KEYS } from "@/constants/auth";

function parseJSON(value, fallback) {
  if (!value) {
    return fallback;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
}

export function getStoredAuthState() {
  return {
    token: window.localStorage.getItem(AUTH_STORAGE_KEYS.token) || "",
    adminInfo: parseJSON(
      window.localStorage.getItem(AUTH_STORAGE_KEYS.adminInfo),
      {}
    ),
    menuTree: parseJSON(
      window.localStorage.getItem(AUTH_STORAGE_KEYS.menuTree),
      []
    ),
    permissionKeys: parseJSON(
      window.localStorage.getItem(AUTH_STORAGE_KEYS.permissionKeys),
      []
    ),
    defaultPath:
      window.localStorage.getItem(AUTH_STORAGE_KEYS.defaultPath) ||
      AUTH_ROUTE_FALLBACK,
    navList: parseJSON(
      window.localStorage.getItem(AUTH_STORAGE_KEYS.navList),
      []
    ),
  };
}

export function persistAuthState(payload = {}) {
  const {
    token = "",
    adminInfo = {},
    menuTree = [],
    permissionKeys = [],
    defaultPath = AUTH_ROUTE_FALLBACK,
    navList = [],
  } = payload;

  if (token) {
    window.localStorage.setItem(AUTH_STORAGE_KEYS.token, token);
  } else {
    window.localStorage.removeItem(AUTH_STORAGE_KEYS.token);
  }

  window.localStorage.setItem(
    AUTH_STORAGE_KEYS.adminInfo,
    JSON.stringify(adminInfo || {})
  );
  window.localStorage.setItem(
    AUTH_STORAGE_KEYS.menuTree,
    JSON.stringify(Array.isArray(menuTree) ? menuTree : [])
  );
  window.localStorage.setItem(
    AUTH_STORAGE_KEYS.permissionKeys,
    JSON.stringify(Array.isArray(permissionKeys) ? permissionKeys : [])
  );
  window.localStorage.setItem(
    AUTH_STORAGE_KEYS.defaultPath,
    defaultPath || AUTH_ROUTE_FALLBACK
  );
  window.localStorage.setItem(
    AUTH_STORAGE_KEYS.navList,
    JSON.stringify(Array.isArray(navList) ? navList : [])
  );
}

export function clearAuthState() {
  Object.values(AUTH_STORAGE_KEYS).forEach((key) => {
    window.localStorage.removeItem(key);
  });
}
